import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { NgClass } from '@angular/common';
import {SidebarComponent} from '@app/partials/sidebar/sidebar.component';
import {HeaderComponent} from '@app/partials/header/header.component';
import { NotificationComponent } from '@app/shared/notification/notification.component';
import { ToastContainerComponent } from '@app/shared/toast/toast-container.component';
import { SidebarStateService } from '@app/partials/sidebar/sidebar-state.service';
import { FeatureToggleService } from '@app/feature-toggles/feature-toggle.service';
import { filter } from 'rxjs';

@Component({
  selector: 'app-app-layout',
  imports: [RouterOutlet, NgClass, SidebarComponent, HeaderComponent, NotificationComponent, ToastContainerComponent],
  templateUrl: './app-layout.component.html',
  styleUrl: './app-layout.component.css',
  standalone: true,
})
export class AppLayoutComponent implements OnInit {
  protected sidebarExpanded = false;
  protected hideSidebar = false;

  constructor(
    private sidebarStateService: SidebarStateService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private featureToggleService: FeatureToggleService,
  ) {}

  ngOnInit(): void {
    this.sidebarExpanded = this.sidebarStateService.isExpanded();
    this.sidebarStateService.stateChange.subscribe((state: boolean) => {
      this.sidebarExpanded = state;
    });
    this.syncRouteLayout();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => this.syncRouteLayout());
    // TVG-100: prime the feature-toggle cache so guards and *@if blocks can read it synchronously.
    this.featureToggleService.loadActive().subscribe();
  }

  private syncRouteLayout(): void {
    let route = this.activatedRoute.firstChild;
    let hideSidebar = false;

    while (route) {
      hideSidebar = hideSidebar || route.snapshot.data['hideSidebar'] === true;
      route = route.firstChild;
    }

    this.hideSidebar = hideSidebar;
  }
}
